module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"notice_title":"[{brand_name} 積分說明]","new_review_button_label_with_mileage":"撰寫評論並最多獲得 %{expected_mileage} 元積分","new_review_button_label":"撰寫評論","max_mileage":"最多 {0} 積分可獲得","no_review_message":"暫無可寫的評價。","money":"元"}}')
  delete Component.options._Ctor
}
